import React from 'react';
import PropTypes from 'prop-types';
import ChipSelection from './chip-selection';

const maritalStatusOptions = [
  {
    label: 'Married',
    value: 'Married'
  },
  {
    label: 'Single',
    value: 'Single'
  },
  {
    label: 'Widowed',
    value: 'Widowed'
  },
];

const MaritalStatusChipSelection = props => {
  const { 'data-cv-test': dataCvTest } = props;

  return (
    <ChipSelection
      name='maritalStatus'
      header='marital status'
      options={maritalStatusOptions}
      data-cv-test="maritalStatus"
      {...props}
      data-cv-test-override={dataCvTest || 'maritalStatus'}
    />
  );
};

MaritalStatusChipSelection.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  error: PropTypes.string,
  'data-cv-test': PropTypes.string
};

MaritalStatusChipSelection.defaultProps = {
  value: '',
  error: '',
  'data-cv-test': ''
};

export default MaritalStatusChipSelection;
